import { eInvoiceStatuses } from '@/constants/e-invoice-statuses'

export default {
  data() {},
  methods: {
    getEInvoiceStatusColor(status) {
      const statusObj = eInvoiceStatuses.find((item) => item.key === status)
      return statusObj ? statusObj.color : 'success'
    },
    isValidToSubmitStatus(status) {
      return !(
        status === 'missing info' ||
        status === 'consolidated' ||
        status === 'valid' ||
        status === 'accepted'
      )
    },
    isReadOnlyStatus(status) {
      return !(
        status === 'rejected' ||
        status === 'consolidated' ||
        status === 'valid' ||
        status === 'accepted'
      )
    },
    isRefreshableStatus(status) {
      return !(
        status === 'rejected' ||
        status === 'consolidated' ||
        status === 'valid'
      )
    },
    isCancelableStatus(status) {
      return status === 'missing info' || status === 'ready to submit'
    },
  },
}
